interface PriceRange {
  minPrice: number;
  maxPrice: number;
  currency: string;
}

export const formatPrice = (priceRange: PriceRange): string => {
  if (!priceRange || (priceRange.minPrice <= 0 && priceRange.maxPrice <= 0)) {
    return "-";
  }

  const formatter = new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency: priceRange.currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  const minPrice = formatter.format(priceRange.minPrice);
  const maxPrice = formatter.format(priceRange.maxPrice);

  return minPrice === maxPrice ? minPrice : `${minPrice} - ${maxPrice}`;
};
